import React, { useState } from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { IRole } from "../../../models/role/Role";
import { RolePicker } from "../../forms/rolePicker/rolePicker";
import { ListActionLabel } from "./listActionLabel";
import styles from "./listActions.css";

interface Props {
  text?: string;
  onPicked(roleId: string): void;
}
export const ListRoleAction = ({
  text = intl.formatMessage("settings.advisers.action.role"),
  onPicked
}: Props) => {
  const [isPicking, setIsPicking] = useState(false);

  const handlePicked = (role: IRole) => {
    onPicked(role.id);
    setIsPicking(false);
  };

  return isPicking ? (
    <RolePicker
      onOutsideClick={() => setIsPicking(false)}
      onChange={handlePicked}
      onStateChange={(_, state) => (!state.isOpen ? setIsPicking(false) : undefined)}
      initialIsOpen
      className={styles["action-dropdown-role"]}
    />
  ) : (
    <ListActionLabel text={text} onClick={() => setIsPicking(true)} />
  );
};
